import WRAP from "WRAP-JS";

const superIndexedJSON = WRAP.Data.Controller.IndexedJSON;
WRAP.Data.Controller.IndexedJSON = (function() {
	return {
		setup: (data) => {
			Object.entries(data.conf).forEach(([key, val]) => {
				if (typeof val.updated === 'function') {
					data.updated(key, ref => {
						val.updated(ref);
					});
				}
			});
			// const controller = WRAP.Data.Controller.IndexedJSON;
			return superIndexedJSON.setup(data);
		}
	}
}());
